import { PageHeader } from "@/components/shared/PageHeader";
import { ContactSection } from "@/components/home/ContactSection";

const IMG = "https://static.prod-images.emergentagent.com/jobs/19db1358-9c8e-4718-a041-5f96f8d9cb74/images/10bb9b715a554c168bcbf6d53dcd2fd24f84404acfc34404d4ac77f7615079b5.jpeg";

export default function Kontakt() {
  return (
    <>
      <PageHeader kicker="Hör av dig" title="Kontakt" subtitle="Tävlingsledning, förarfrågor, media och sponsorer." image={IMG} />
      <ContactSection />
    </>
  );
}
